// noinspection JSUnusedLocalSymbols
const text = require('./text.yaml')[templateVars.lang];
const CBusinessModelPage = require('../../index.js');

class CBusinessModelPageBase extends CBusinessModelPage {
	constructor() {
		super();
		this.intervals = {};
	}
	init() {
		if ($('#operation_model').length < 1) {
			return;
		}
		// const scrollDivNode = $('.custom-navigation nav > div.js-scrollup');
		// this.navHeight = scrollDivNode.offset().top + scrollDivNode.height() - $('.custom-navigation nav').offset().top;
		document.querySelectorAll('[data-svg-id]').forEach(node => {
			node.setAttribute('id', node.getAttribute('data-svg-id'));
		});
		$(document).scroll(() => {
			// this.setNavPosition();
			this.checkCounters();
		});
		$(window).resize(() => {
			// this.setNavPosition();
			this.checkCounters();
		});
	}
	// setNavPosition() {
	// 	const nav = $('.custom-navigation');
	// 	if ($(document).scrollTop() > $('main').offset().top + 10 - $(window).height() / 2 + this.navHeight / 2) {
	// 		const right = $(window).width() - $('.operation .operation__right:first').offset().left + 36;
	// 		nav.addClass('__fixed');
	// 		nav.css('right', right + 'px');
	// 	} else {
	// 		nav.removeClass('__fixed');
	// 		nav.css('right', '');
	// 	}
	// }
	checkCounters() {
		$('span[data-total]').each((i, el) => {
			if (el.innerText === '0' && $(document).scrollTop() + $(window).height() > $(el).offset().top) {
				const total = parseFloat($(el).attr('data-total'));
				const step = total / 100;
				if (typeof this.intervals[i] !== 'undefined') {
					return;
				}
				this.intervals[i] = setInterval(() => {
					const next = parseFloat($(el).attr('data-current')) + step;
					if (next >= total) {
						$(el).text(total.toLocaleString('en-US'));
						$(el).attr('data-current', total);
						clearInterval(this.intervals[i]);
					} else {
						$(el).attr('data-current', next);
						$(el).text(Math.floor(next).toLocaleString('en-US'));
					}
				}, 20);
			}
		});
	}
}

AR.waitComponents(['cPreloader_base'], () => {
	const component = new CBusinessModelPageBase();
	component.init();
	AR.pushComponent(component, 'business_model_base');
});
